import { attachAuthInterceptors } from '@repo/auth/axios';
import axios from 'axios';

import { authClient } from 'src/app/auth/auth-client';
import { getLocale } from 'src/packages/language/utils';

import { API_USER_FILES_URL } from './consts';

const userFileGenerationAgent = axios.create({
  baseURL: API_USER_FILES_URL + '/v2',
  headers: {
    'content-type': 'application/json',
  },
});

attachAuthInterceptors(userFileGenerationAgent, authClient);

userFileGenerationAgent.interceptors.request.use((config) => {
  config.headers.set('accept-language', getLocale());
  return config;
});

export { userFileGenerationAgent };
